import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import DevotionalTypes from "@/pages/DevotionalTypes";
import Devotionals from "@/pages/Devotionals";
import VerseOfTheDay from "@/pages/VerseOfTheDay";
import Bible from "@/pages/Bible";
import Settings from "@/pages/Settings";
import AccountSettings from "@/pages/AccountSettings";
import AdminUsers from "@/pages/AdminUsers";
import Privacy from "@/pages/Privacy";
import Unsubscribe from "@/pages/Unsubscribe";
import DataDeletionRequests from "@/pages/DataDeletionRequests";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route element={<AppShell />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/devotional-types" element={<DevotionalTypes />} />
              <Route path="/devotionals" element={<Devotionals />} />
              <Route path="/verse-of-the-day" element={<VerseOfTheDay />} />
              <Route path="/bible" element={<Bible />} />
              <Route path="/settings" element={<Navigate to="/system-config" replace />} />
              <Route path="/system-config" element={<Settings />} />
              <Route path="/settings/account" element={<AccountSettings />} />
              <Route path="/data-deletion-requests" element={<DataDeletionRequests />} />
              <Route path="/admin-users" element={<AdminUsers />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
